<template>
    <div :class="[colorBg, 'rounded-md p-4']">
        <div class="flex">
            <div
                v-if="isIcon"
                class="flex-shrink-0">
                <Component
                    :is="icon"
                    :class="[colorIc, 'h-5 w-5']"
                    aria-hidden="true"
                />
            </div>

            <div class="ml-3">
                <h3 :class="[colorTt, 'text-sm font-medium']">
                    {{ title }}
                </h3>

                <div :class="['mt-2 text-sm', colorCt]">
                    <p v-html="content" />
                </div>

                <div
                    v-if="buttons"
                    class="mt-4"
                >
                    <div class="-mx-2 -my-1.5 flex">
                        <template
                            v-for="button in buttons"
                            :key="`alert_button_${button.content}`"
                        >
                            <RouterLink
                                v-if="button.router"
                                :to="{name: button.router, params: button?.params}"
                                :class="[
                                    'px-2 py-1.5 rounded-md text-sm font-medium chat_transition',
                                    `${colorBgHov} ${colorTt} ${colorBgFoc} ${colorRgFoc} focus:outline-none focus:ring-2 focus:ring-offset-2`,
                                ]"
                            >
                                {{ button.content }}
                            </RouterLink>

                            <a
                                v-if="button.link"
                                :href="button.link"
                                target="_blank"
                                :class="[
                                    'px-2 py-1.5 rounded-md text-sm font-medium chat_transition',
                                    `${colorBgHov} ${colorTt} ${colorBgFoc} ${colorRgFoc} focus:outline-none focus:ring-2 focus:ring-offset-2`,
                                ]"
                            >
                                {{ button.content }}
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <span
        :class="[
            'bg-yellow-50',
            'hover:bg-yellow-100',
            'focus:ring-offset-yellow-50',
            'focus:ring-yellow-700',
            'text-yellow-400',
            'text-yellow-700',
            'text-yellow-800',
            'hover:text-yellow-800',

            'bg-blue-50',
            'hover:bg-blue-100',
            'focus:ring-offset-blue-50',
            'focus:ring-blue-700',
            'text-blue-400',
            'text-blue-700',
            'text-blue-800',
            'hover:text-blue-800',

            'bg-red-50',
            'hover:bg-red-100',
            'focus:ring-offset-red-50',
            'focus:ring-red-700',
            'text-red-400',
            'text-red-700',
            'text-red-800',
            'hover:text-red-800',

            'bg-green-50',
            'hover:bg-green-100',
            'focus:ring-offset-green-50',
            'focus:ring-green-700',
            'text-green-400',
            'text-green-700',
            'text-green-800',
            'hover:text-green-800',

            'sr-only'
        ]"
    />
</template>

<script>
    import { CheckCircleIcon, ExclamationIcon, InformationCircleIcon, XCircleIcon} from '@heroicons/vue/solid'

    export default {
        name: 'FeedbackAlert',
        components: {CheckCircleIcon, ExclamationIcon, InformationCircleIcon, XCircleIcon},
        props: {
            isIcon: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                required: true,
            },
            content: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            buttons: {
                type: Array,
                default: null,
            },
        },

        data() {
            const icon = {alert: ExclamationIcon, warning: ExclamationIcon, success: CheckCircleIcon, error: XCircleIcon, info: InformationCircleIcon}
            const color = {alert: 'yellow', warning: 'yellow', success: 'green', error: 'red', info: 'blue'}

            return {
                icon: icon[this.type] || InformationCircleIcon,
                colorBgHov: `hover:bg-${color[this.type] || 'gray'}-100`,
                colorBgFoc: `focus:ring-offset-${color[this.type] || 'gray'}-50`,
                colorRgFoc: `focus:ring-${color[this.type] || 'gray'}-700`,
                colorBg: `bg-${color[this.type] || 'gray'}-50`,
                colorIc: `text-${color[this.type] || 'gray'}-400`,
                colorCt: `text-${color[this.type] || 'gray'}-700`,
                colorTt: `text-${color[this.type] || 'gray'}-800 hover:text-${color[this.type] || 'gray'}-800`,
            }
        },
    }
</script>